import { observable, action, computed, toJS } from 'mobx';

const DEFAULT_ITEM_COUNT = 0;
const DEFAULT_CURRENT_PAGE = 1;
const DEFAULT_PER_PAGE = 25;

export default class PagerStore {
  @observable itemCount = DEFAULT_ITEM_COUNT;
  @observable currentPage = DEFAULT_CURRENT_PAGE;
  @observable perPage = DEFAULT_PER_PAGE;

  constructor(rawState = {}) {
    if(rawState.itemCount) {
      this.setItemCount(rawState.itemCount);
    }
    if(rawState.currentPage) {
      this.setCurrentPage(rawState.currentPage);
    }
    if(rawState.perPage) {
      this.setPerPage(rawState.perPage);
    }
  }

  @computed get firstShownItem() {
    if(this.itemCount === 0) {
      return 0;
    }
    return ((this.currentPage - 1) * this.perPage) + 1;
  }
  @computed get lastShownItem() {
    if(this.itemCount === 0) {
      return 0;
    }
    const max = this.currentPage * this.perPage;
    return this.itemCount < max ? this.itemCount : max;
  }

  @computed get firstShownPage() {
    const first = this.currentPage - 5;
    return first > 0 ? first : 1;
  }

  @computed get lastShownPage() {
    const last = this.currentPage + 5;
    return last < this.pageCount ? last : this.pageCount;
  }

  @computed get pageCount() {
    if(this.itemCount === 0) {
      return 1;
    }
    return Math.ceil(this.itemCount / this.perPage);
  }

  @action setItemCount(itemCount) {
    this.itemCount = itemCount;
    if(this.currentPage > this.pageCount) {
      this.currentPage = this.pageCount;
    }
  }
  @action setCurrentPage(currentPage) {
    if(this.pageCount > 0 && currentPage > this.pageCount) {
      currentPage = this.pageCount;
    }
    this.currentPage = currentPage;
  }
  @action setPerPage(value) {
    this.perPage = value;
    if(this.currentPage > this.pageCount) {
      this.setCurrentPage(this.pageCount);
    }
  }

  @computed get pages() {
    const pages = [];
    for(let page = this.firstShownPage; page <= this.lastShownPage; pages.push(page++)){}
    return pages;
  }
  @computed get nextPage() {
    return this.currentPage < this.pageCount ? this.currentPage + 1 : null;
  }
  @computed get prevPage() {
    return this.currentPage > 1 ? this.currentPage - 1 : null;
  }
  toJS() {
    const js = {};
    if(this.itemCount && this.itemCount !== DEFAULT_ITEM_COUNT) {
      js.itemCount = toJS(this.itemCount);
    }
    if(this.currentPage && this.currentPage !== DEFAULT_CURRENT_PAGE) {
      js.currentPage = toJS(this.currentPage);
    }
    if(this.perPage && this.perPage !== DEFAULT_CURRENT_PAGE) {
      js.perPage = toJS(this.perPage);
    }
    return Object.keys(js).length ? js : undefined;
  }
}